import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import { Container, i18n } from '../../../../symphony';
import { aIChatPlaygroundContext } from '../../aIChatPlaygroundConstants';
import { AIChatPlaygroundService } from '../../services/AIChatPlaygroundService';
import { Tab } from '../../aIChatPlaygroundInterface';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import s from './AIChatPlaygroundNav.scss';

export const AIChatPlaygroundNav = () => {
	useStyles(s);
	const { setActiveTab } = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);
	const { configs, modelConfigs } = useContainerData(
		aIChatPlaygroundContext.value,
		AIChatPlaygroundStore,
		['configs', 'modelConfigs'],
	);

	return (
		<div className="ai-chat-playground-nav">
			<div
				className={classNames('ai-chat-playground-nav__item', configs.selectedTab === Tab.Chat && 'active')}
				onClick={() => { setActiveTab(Tab.Chat); }}
			>
				{i18n.t('ai-chat.tabs.chat')}
			</div>
			{
				!!modelConfigs?.length
				&& (
					<div
						className={classNames('ai-chat-playground-nav__item', configs.selectedTab === Tab.Settings && 'active')}
						onClick={() => { setActiveTab(Tab.Settings); }}
					>
						{i18n.t('ai-chat.tabs.settings')}
					</div>
				)
			}
		</div>
	);
};
